import { useEffect } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBackRounded';
import CloseIcon from '@mui/icons-material/CloseRounded';
// icons and ui
import { Box, Popover } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import { setOnboaringStatus, setOnboaringStep } from '../../../redux/onboarding/onboardingActions';
// utils
import { updateOnboardingStatus } from '../../../services/user.service';
import ButtonComponent from '../ButtonComponent/ButtonComponent';
// styles
import './_onboarding.scss';

import { useNavigate } from 'react-router-dom';

import { onboardingData as onboardingDataArray } from '../../../utils/data/onboardingData';
import { Mixpanel } from '../../../utils/mixpanel';

export default function PopoverComponent({ anchorEl, setAnchorEl, onboardingData }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const percentComplete = ((onboardingData.step - 1) / 12) * 100;
  const { userDetails } = useSelector((state) => state.user);
  const handleFinish = async () => {
    Mixpanel.identify(userDetails?._id);
    Mixpanel.people.set({
      'Percentage Tour Completed': percentComplete.toFixed(2),
    });
    const response = await updateOnboardingStatus();
    dispatch(setOnboaringStatus(true));
    dispatch(setOnboaringStep(999));
    anchorEl.style.zIndex = 9;
    setAnchorEl(null);
    document.querySelector('.root-overlay-container').style.display = 'none';
  };

  useEffect(() => {
    if (anchorEl) {
      anchorEl.style.zIndex = 9999;
    }
  }, [anchorEl]);

  return (
    <Popover
      id={Boolean(anchorEl) ? 'simple-popover' : undefined}
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: [11, 13].includes(onboardingData.step) ? 'bottom' : 'top',
        horizontal: [12].includes(onboardingData.step) ? 'left' : 'right',
      }}
      transformOrigin={{
        vertical: [12].includes(onboardingData.step) ? 'bottom' : 'top',
        horizontal: [11, 13].includes(onboardingData.step) ? 'right' : 'left',
      }}
      sx={{
        marginLeft:
          onboardingData?.step === 12
            ? 0
            : [4, 11, 13].includes(onboardingData.step)
              ? '10px'
              : [11, 10].includes(onboardingData.step)
                ? '10px'
                : '10px',
        zIndex: 9999,
      }}
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          borderRadius: 0,
        },
      }}>
      <Box
        sx={
          [11, 12, 13].includes(onboardingData.step)
            ? {
                position: 'relative',
                mt: onboardingData.step === 12 ? '0' : '10px',
                mb: onboardingData.step === 12 ? '10px' : '0',
                '&::before': {
                  backgroundColor: 'white',
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  width: 12,
                  height: 12,
                  top: onboardingData.step === 12 ? 'auto' : -6,
                  bottom: onboardingData.step === 12 ? -6 : 'auto',
                  left: onboardingData.step === 12 ? '22px' : 'auto',
                  right: onboardingData.step === 12 ? 'auto' : '22px',
                  transform: 'rotate(45deg)',
                },
              }
            : {
                position: 'relative',
                ml: '10px',
                '&::before': {
                  backgroundColor: 'white',
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  width: 12,
                  height: 12,
                  top: [10, 11, 9].includes(onboardingData.step) ? (onboardingData.step === 9 ? '70px' : null) : '20px',
                  transform: 'rotate(45deg)',
                  left: onboardingData.step === 12 ? 'auto' : -6,
                  bottom: onboardingData.step === 11 ? '20px' : onboardingData.step === 10 ? '65px' : null,
                },
              }
        }>
        <div className="onboarding-card" style={{ width: onboardingData?.step === 13 ? '420px' : '390px' }}>
          <div className="onboarding-progress-container">
            <div className="progress-percentage ">{percentComplete.toFixed()}%</div>
            <div className="progress-bar-container">
              <div className="progress-bar-background" />
              <div className="progress-bar" style={{ width: `${percentComplete}%` }} />
            </div>
            <button className="close-btn" onClick={handleFinish}>
              <CloseIcon />
            </button>
          </div>
          <div className="onboarding-card-header">
            <h2 className="title">{onboardingData.title}</h2>
          </div>
          <div className="onboarding-text" dangerouslySetInnerHTML={{ __html: onboardingData.description }} />
          <div className="onboarding-card-footer">
            <div />
            {/* <p className="onboarding-card-number">{onboardingData.step}/14</p> */}
            <div className="onboarding-card-buttons">
              {onboardingData.step > 1 && (
                <ButtonComponent
                  variant="light"
                  onClick={() => {
                    const previousStep = onboardingData.step - 1;
                    const previousOnboardingData = onboardingDataArray.find((s) => s.step === previousStep);
                    if (previousOnboardingData.navigateTo) {
                      navigate(previousOnboardingData.navigateTo);
                    }
                    dispatch(setOnboaringStep(onboardingData.step - 1));
                    anchorEl.style.zIndex = 9;
                    setAnchorEl(null);
                  }}>
                  <ArrowBackIcon />
                </ButtonComponent>
              )}
              {onboardingData.step === 13 ? (
                <ButtonComponent variant="primary" onClick={handleFinish}>
                  Finish
                </ButtonComponent>
              ) : (
                <ButtonComponent
                  variant="primary"
                  style={{ fontSize: '19px' }}
                  onClick={() => {
                    const nextStep = onboardingData.step + 1;
                    const nextOnboardingData = onboardingDataArray.find((s) => s.step === nextStep);
                    if (nextOnboardingData.navigateTo) {
                      navigate(nextOnboardingData.navigateTo);
                    }
                    if (nextStep === 13) {
                      navigate('/dashboard');
                    }
                    dispatch(setOnboaringStep(nextStep));
                    setAnchorEl(null);
                    anchorEl.style.zIndex = 9;
                  }}>
                  Next
                </ButtonComponent>
              )}
            </div>
          </div>
        </div>
      </Box>
    </Popover>
  );
}
